module.exports = __webpack_public_path__ + "img/produk-placeholder.cf3f3554.png";